module.exports = __webpack_public_path__ + "static/media/selectArrowUp.482224d8.svg";